import Spinner from 'src/javascripts/components/utilities/Spinner';
import {filterTypeahead} from 'src/javascripts/components/typeaheads/TypeaheadBloodhounds';
import {noResultsTemplate, genericDisplayTemplate} from 'src/javascripts/components/typeaheads/TypeaheadTemplates';
import 'src/javascripts/vendor/typeahead.jquery';
import 'src/javascripts/vendor/bloodhound';

// Must define Bloodhound explicitly here
// https://stackoverflow.com/questions/30750916/how-to-reference-typeahead-and-bloodhound-when-loading-npm-typeahead-js
const Bloodhound = require('src/javascripts/vendor/bloodhound');


export default function() {

  // Set vars
	let accountUrl = $('body').attr('data-account-url');

  // Display question results
  const questionDisplayAllTemplate = (name, metric, category, id) => '<div class=\'card mb-2 clickable bg-gray100 question-search-option\' data-question-text=\'' + name + '\' data-question-id=\'' + id + '\'>' +
    '<div class=\'card-body\'><div class="mb-1 text-gray600" style=\'font-size: 13px; font-family: Inter;\'>' + name + '</div>' +
    '<div class=\'text-gray500\' style=\'font-size: 11px; font-family: Inter;\'>' + category + '</div>' +
    '</div></div>';

  // Questions search
  let questionsBloodhound = new Bloodhound({
    datumTokenizer: Bloodhound.tokenizers.obj.whitespace('name'),
    queryTokenizer: Bloodhound.tokenizers.whitespace,
    remote: {
      url: '/' + accountUrl + '/surveys/questions?query=%QUERY',
      wildcard: "%QUERY",
      cache: false
    }});
  questionsBloodhound.initialize();
  $('#questions_search').typeahead({
    hint: true,
    highlight: true,
    minLength: 0,
    classNames: {
      menu: 'd-none' // add class name to menu so default dropdown does not show
    }
  }, {
    name: 'questions',
    display: 'name',
    limit: 351,
    source: questionsBloodhound.ttAdapter(),
    menu: '#questionsSearchResults'
  });

  $('#questions_search').on('typeahead:render', function (e, datum) {
    $('#questionsSearchResults').empty();
    $('#questionsSearchResults').closest('.form-group').removeClass('d-none');
  	Spinner($('#questionsSearchResults'));
    var suggestions = Array.prototype.slice.call(arguments, 1);
    if ((typeof suggestions[0] !== 'undefined') && (suggestions[0].length > 0)) {

      //empty suggestion div to display results
      for (var c = 0; c < suggestions[0].length; c++) {

        // Set template to render
        let template;
      	template = questionDisplayAllTemplate(suggestions[0][c].name, suggestions[0][c].metric, suggestions[0][c].category, suggestions[0][c].record_id);

        // Append to companies search list
        $('#questionsSearchResults').append(template);

      }

	    // Remove spinner
	    $('#questionsSearchResults').find('.spinner-container').remove();

    } else {

      // Append to companies search list
      $('#questionsSearchResults').find('.spinner-container').remove();
      $('#questionsSearchResults').empty().append("No questions found")
      
    }

	  // Update selected on click 
	  $('.question-search-option').click(function(ev) {
	    let qid = $(this).attr('data-question-id');
	    let qText = $(this).attr('data-question-text');
	    $('#existing_question_id').val(qid);
	    $('#questions_search').val(qText);
	    $('#questionsSearchResults').closest('.form-group').addClass('d-none');
	  });

  });
  
  // On clear typeahead
  $('.clear-questions-typeahead').click(function() {
    $('#existing_question_id').val("");
    $('#questions_search').typeahead("val", "");
    $('#questions_search').focus();
    $('#questionsSearchResults').closest('.form-group').removeClass('d-none');
  })

  // Focus questions
  if ($('#questions_search').length !== 0) {
    $('#questions_search').focus();
  }


}